// dependencies
import React from 'react';
import PropTypes from 'prop-types';
// child components
import IconHeader from '../../../../../../shared/components/IconHeader/IconHeader';
import AdditionalInfo from './children/AdditionalInfo';
import DateAndMultiSelect from './children/DateAndMultiSelect/DateAndMultiSelect';
import AirlineSelections from './children/AirlineSelections/AirlineSelections';

const CompileDataForm = props => (
  <div className='export-compile-form-container'>
    <div className='header'>
      <IconHeader
        icon={props.headerIcon}
        title='Compile Data Export'
      />
    </div>
    <div className='row'>
      <p className='selector-explain'>Use these filters to narrow down data</p>
      <DateAndMultiSelect
        arrivalCheckedSearch={props.arrivalCheckedSearch}
        arrivalCheckedSearchInvalid={props.arrivalCheckedSearchInvalid}
        departureCheckedSearch={props.departureCheckedSearch}
        departureCheckedSearchInvalid={props.departureCheckedSearchInvalid}
        dispatch={props.dispatch}
        airlines={props.airlines}
        arrivalAirports={props.arrivalAirports}
        departureAirports={props.departureAirports}
        arrivalCountries={props.arrivalCountries}
        departureCountries={props.departureCountries}
        arrivalRegions={props.arrivalRegions}
        departureRegions={props.departureRegions}
        params={props.params}
        inputObjectDefaults={props.inputObjectDefaults}
        selectedEndDate={props.selectedEndDate}
        selectedEndDateInvalid={props.selectedEndDateInvalid}
        selectedStartDate={props.selectedStartDate}
        selectedStartDateInvalid={props.selectedStartDateInvalid}
        serverDate={props.serverDate}
        user={props.user}
      />
      <AirlineSelections
        airlines={props.airlines}
        dispatch={props.dispatch}
        includeCargo={props.includeCargo}
        includeCodeshares={props.includeCodeshares}
        inputObjectDefaults={props.inputObjectDefaults}
      />
      <div className='data-export-info-container col-xs-12'>
        <AdditionalInfo
          formReset={props.formReset}
          industries={props.industries}
          inputObjectDefaults={props.inputObjectDefaults}
          onSubmit={props.onSubmit}
          userIndustrySelect={props.userIndustrySelect}
          userIndustrySelectInvalid={props.userIndustrySelectInvalid}
          userExportIntendedUse={props.userExportIntendedUse}
          userExportIntendedUseInvalid={props.userExportIntendedUseInvalid}
        />
      </div>
    </div>
  </div>
);

CompileDataForm.propTypes = {
  airlines: PropTypes.array,
  arrivalAirports: PropTypes.array,
  arrivalCountries: PropTypes.array,
  departureAirports: PropTypes.array,
  arrivalRegions: PropTypes.array,
  departureCountries: PropTypes.array,
  arrivalCheckedSearch: PropTypes.string,
  arrivalCheckedSearchInvalid: PropTypes.string,
  departureRegions: PropTypes.array,
  departureCheckedSearch: PropTypes.string,
  departureCheckedSearchInvalid: PropTypes.string,
  dispatch: PropTypes.func,
  formReset: PropTypes.func,
  headerIcon: PropTypes.string,
  includeCodeshares: PropTypes.bool,
  includeCargo: PropTypes.bool,
  industries: PropTypes.array,
  inputObjectDefaults: PropTypes.object,
  onSubmit: PropTypes.func,
  params: PropTypes.object,
  selectedEndDate: PropTypes.object,
  selectedEndDateInvalid: PropTypes.string,
  selectedStartDate: PropTypes.object,
  selectedStartDateInvalid: PropTypes.string,
  serverDate: PropTypes.object,
  user: PropTypes.object,
  userExportIntendedUse: PropTypes.string,
  userExportIntendedUseInvalid: PropTypes.string,
  userIndustrySelect: PropTypes.string,
  userIndustrySelectInvalid: PropTypes.string,
};

export default CompileDataForm;



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/CompileDataForm.js